import React, { Suspense, useEffect, useRef, useState } from "react";
import "./styles.css";
import Control from "./Control";
import Hero from "./Hero/Hero";
import Announcement from "./Announcement";
import CountdownBar from "./CountdownBar";

const SectionWithSwiper = React.lazy(() => import("./SectionWithSwiper/SectionWithSwiper"));
const ADTporque = React.lazy(() => import("./ADTporque"));
const Seguridad = React.lazy(() => import("./Seguridad"));
const WhatsappSection = React.lazy(() => import("./WhatsappSection"));
const FaqsSection = React.lazy(() => import("./FaqsSection"));
const NuevoSistema = React.lazy(() => import("./NuevoSistema"));

const DeferredSection = ({ children, minHeight = 320 }) => {
  const ref = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (shouldRender) return undefined;

    const node = ref.current;
    if (!node) return undefined;

    if (!("IntersectionObserver" in window)) {
      setShouldRender(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin: "700px 0px" }
    );

    observer.observe(node);

    return () => observer.disconnect();
  }, [shouldRender]);

  return (
    <div
      ref={ref}
      className="deferredSection"
      style={shouldRender ? undefined : { minHeight }}
    >
      {shouldRender ? (
        <Suspense fallback={<div style={{ minHeight }} aria-hidden="true" />}>
          {children}
        </Suspense>
      ) : null}
    </div>
  );
};

const Home = () => {
  return (
    <div className="home">
      <Announcement />
      <Hero heroImage="/og-image.jpg" />
      <Control />
      <DeferredSection minHeight={620}>
        <SectionWithSwiper />
      </DeferredSection>
      <DeferredSection minHeight={430}>
        <ADTporque />
      </DeferredSection>
      <DeferredSection minHeight={360}>
        <Seguridad />
      </DeferredSection>
      <DeferredSection minHeight={260}>
        <WhatsappSection />
      </DeferredSection>
      <DeferredSection minHeight={520}>
        <FaqsSection />
      </DeferredSection>
      <DeferredSection minHeight={520}>
        <NuevoSistema />
      </DeferredSection>
      <footer className="footer">
        <div className="container-lg flex flexCol alignCenter">
          <p>{new Date().getFullYear()} Alarmita.com - ADT Agente Oficial</p>
        </div>
      </footer>
      <CountdownBar />
    </div>
  );
};

export default Home;
